module.exports = __webpack_public_path__ + "media/application/images/ui/icon-padlock-9999390dd10a272d262c68aa8a83a0f8.png";